console.log('REACT_APP_API_ENDPOINT:', process.env.API_ENDPOINT);
console.log('REACT_APP_API_USERNAME:', process.env.API_USERNAME);
console.log('REACT_APP_API_PASSWORD:', process.env.API_PASSWORD);

export const API_CONFIG = {
    endpoint: "https://api.walawork.com", //process.env.API_ENDPOINT,
    credentials: {
      username: process.env.API_USERNAME,
      password: process.env.API_PASSWORD,
    },
  };
  